import React from 'react';
import { Modal, Table, Form, Empty, Input, Button, Tooltip } from 'antd';
import TextArea from 'antd/lib/input/TextArea';

class AgregarSerieModal extends React.Component {
       constructor(props) {
        super(props);
        this.state = {
            serie: ''
        }
    }


    handleOk = (e) => {
        debugger;
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            debugger;
            console.log(values);

            if (!err) {
                const form = {
                    idProducto: values.idProducto,
                    serie: values.serie,
                    onCalculateDetail: values.onCalculateDetail,
                    setFieldsValueDetalle: values.setFieldsValueDetalle,
                    getFieldValueDetalle: values.getFieldValueDetalle,
                }
                this.props.onAgregarSerieDetalle(form, this.props.form);

                this.props.form.setFieldsValue({
                serie: ''
                });
            }
        });
    }

    handleCancel = () => {
        this.props.form.setFieldsValue({
                serie: ''
        });
        this.props.onCancel();
    };


render() {
        const { getFieldDecorator } = this.props.form;
        getFieldDecorator('idProducto', { initialValue: this.props.formValues.idProducto });
        getFieldDecorator('onCalculateDetail', { initialValue: this.props.formValues.onCalculateDetail });
        getFieldDecorator('setFieldsValueDetalle', { initialValue: this.props.formValues.setFieldsValueDetalle });
        getFieldDecorator('getFieldValueDetalle', { initialValue: this.props.formValues.getFieldValueDetalle });
        return (
            <Modal
                title={"Agregar Serie (" + this.props.formValues.codigoProducto + " - " + this.props.formValues.nombreProducto + ")" }
                visible={this.props.visible}
                style={{ top: 30 }}
                width="800px"
                onCancel={(properties) => {
                    if (
                        !properties.target.className.toString().match("ant-modal-wrap") ||
                        properties.type === "keydown"
                    )
                    this.handleCancel();
                }}
                footer={[
                    <Button
                        key="send"
                        type="primary"
                        onClick={this.props.onCancel}
                    >
                        Cerrar
                    </Button>
                ]}
            >
                <Form>
                    <div className="row">
                         <div className="col-md-10 form-group">
                                <Form.Item label="">
                                {getFieldDecorator('serie', {
                                    initialValue: this.props.formValues.serie,                                    
                                    rules: [
                                    {
                                        required: true,
                                        message: "Campo obligatorio.",
                                    },
                                    ]
                                })(
                                    <Input
                                    // style={{ textTransform: "uppercase" }}
                                    placeholder="Ingrese Serie"
                                    autoComplete="off"
                                    />
                                )}
                                </Form.Item>                              
                            </div>
                         <div className="col-md-2 form-group">
                           
                           <Button
                                icon="plus"
                                style={{marginTop:5}}
                                type="primary"
                               onClick={this.handleOk}
                                >
                                    Agregar
                            </Button>
                        </div>
                    </div>
                    
                    <div className="row">
                        <div className="col-md-12">
                            <Table
                                size="small"
                                style={{ overflowX: 'auto' }}
                                rowKey={record => record.id}
                                dataSource={this.props.formValues.listaDetalleSerie}
                                // rowSelection={{
                                //      onChange: this.props.onChangeRow,
                                //      selectedRowKeys: this.props.formValues.selectedRowKeys,
                                //      hideDefaultSelections: false
                                //  }}
           
                                locale={{
                                    emptyText: <Empty
                                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                                        description="Agregue series."
                                    />
                                }}
                                columns={[
                                    {
                                        key: 'remove-button',
                                        align: 'center',
                                        width: 40,
                                        fixed: 'left',
                                        render: (value, row) => (
                                            <span>
                                                <div className="custom-options">
                                                    <Tooltip placement="top" title="Remover">
                                                        <Button
                                                            type="danger"
                                                            icon="delete"
                                                            size={"small"}
                                                            onClick={() => this.props.onRemove(row, this.props.formValues.onCalculateDetail)}
                                                        />
                                                    </Tooltip>
                                                </div>
                                            </span>
                                        )
                                    },
                                    {
                                        title: 'Serie',
                                        dataIndex: 'serie',
                                        key: 'serie'
                                    }
                                ]}
                            />
                        </div>
                    </div>
                </Form>
            </Modal>
        );
    }
}
export default Form.create()(AgregarSerieModal)